import React from "react";

type Feature = {
    icon: string;
    title: string;
    desc: string;
};

const featuresLeft: Feature[] = [
    {
        icon: "/icon_1.png",
        title: "Soluciones 100% adaptadas a tu negocio",
        desc:
            "No compras un producto genérico, desarrollamos software a tu medida, optimizado para tus procesos y objetivos.",
    },
    {
        icon: "/icon_2.png",
        title: "Tecnología moderna y escalable",
        desc:
            "Construimos soluciones robustas y seguras que crecen con tu empresa, evitando futuras migraciones costosas.",
    },
    {
        icon: "/icon_3.png",
        title: "Talento especializado a tu alcance",
        desc:
            "Accede a profesionales con experiencia en múltiples industrias, sin la carga de contrataciones internas complejas.",
    },
];

const featuresRight: Feature[] = [
    {
        icon: "/icon_4.png",
        title: "Ahorro de tiempo y costos operativos",
        desc:
            "Externalizar el desarrollo te permite concentrarte en tu negocio principal.",
    },
    {
        icon: "/icon_5.png",
        title: "Implementación ágil y soporte continuo",
        desc:
            "Metodologías modernas que reducen tiempos de entrega y garantizan acompañamiento técnico post-implementación.",
    },
    {
        icon: "/icon_6.png",
        title: "Menor riesgo en proyectos tecnológicos",
        desc:
            "Experiencia comprobada que disminuye errores y asegura un desarrollo alineado a estándares de calidad.",
    },
];

const Card: React.FC<Feature> = ({ icon, title, desc }) => (
    <article className="rounded-2xl bg-[#F6F7F9] p-5 shadow-sm ring-1 ring-slate-100 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 cursor-pointer h-full flex flex-col">
        <div className="flex items-start gap-3">
            <img
                src={icon}
                alt=""
                className="h-10 w-10 rounded-lg object-contain flex-shrink-0"
                loading="lazy"
            />
            <h3 className="text-slate-900 text-base font-semibold leading-snug">
                {title}
            </h3>
        </div>
        <p className="mt-2 text-slate-600 text-sm leading-relaxed flex-grow">{desc}</p>
    </article>
);

const WhyChooseUsSection: React.FC = () => {
    return (
        <section className="w-full bg-white">
            <div className="mx-auto max-w-7xl px-6 md:px-8">
                {/* Wrapper ancho con fondo y bordes redondeados */}
                <div className="rounded-2xl px-6 py-10 md:px-10 md:py-14 shadow-sm">
                    {/* Badge */}
                    <div className="mb-4 flex justify-center">
                        <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 shadow-sm">
                            <img src="/icons/why.svg" alt="¿Por qué elegirnos?" className="h-4 w-4" />
                            ¿Por qué elegirnos?
                        </span>
                    </div>

                    {/* Título */}
                    <h2 className="text-center text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
                        Donde marcamos la diferencia
                    </h2>

                    {/* Grid principal */}
                    <div className="mt-10 grid gap-6 lg:mt-12 lg:grid-cols-3">
                        {/* Columna izquierda */}
                        <div className="order-2 grid grid-rows-3 gap-4 lg:order-1">
                            {featuresLeft.map((f, i) => (
                                <Card key={`l-${i}`} {...f} />
                            ))}
                        </div>

                        {/* Imagen central (arriba en móvil) */}
                        <div className="order-1 -mx-2 flex items-end rounded-2xl justify-center lg:order-2 lg:mx-0 bg-[#F6F7F9]">
                            <img
                                src="/application.png"
                                alt="Dispositivo móvil"
                                className="mx-auto"
                                loading="lazy"
                            />
                        </div>

                        {/* Columna derecha */}
                        <div className="order-3 grid grid-rows-3 gap-4">
                            {featuresRight.map((f, i) => (
                                <Card key={`r-${i}`} {...f} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUsSection;
